import React from "react";
import {
  Button,
  FlexDirectionRow,
  FormContainer,
  MainContent,
  SubTitle,
} from "../../../../../components/StyledComponents";
import Input from "../../../../../components/InputControlled";
import TextArea from "../../../../../components/TextArea";
import { useForm } from "react-hook-form";
import { valueIsRequired } from "../../../../../utils/regex";
import { TipoRegistroService } from "../../../services/tipoRegistroService";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import { BaSeDialogContext } from "@base/react";
import Spinner from "react-spinner-material";
import { useApp } from "../../../../../context/app";

export const IncluirTipoRegistro = () => {
  const { setRenderIncludeScreen } = useApp();
  const { control, handleSubmit, formState, reset } = useForm({
    defaultValues: {
      nome: '',
      tipo: '',
      descricao: '',
      acaoRegistro: '',
      regrasServico: '',
      status: '',
    },
  });
  const { isSubmitting } = formState;
  const { showModal } = React.useContext(BaSeDialogContext);

  const handleGoHome = () => {
    setRenderIncludeScreen(false);
  };

  const submitForm = async (dataForm) => {
    const dataToSubmit = {
      nome: dataForm.nome,
      tipo: dataForm.tipo,
      descricao: dataForm.descricao,
      acaoRegistro: dataForm.acaoRegistro,
      regrasServico: dataForm.regrasServico,
      status: "REPROVADO",
    };
    try {
      const response = await TipoRegistroService.save(dataToSubmit);
      handleModalStatus({
        type: "success",
        msgOnSuccess: "Tipo de registro adicionado com sucesso.",
        onCloseModal: handleGoHome,
        showModal,
      });
      return response;
    } catch (e) {
      if (
        e.response?.data?.message.includes(
          "Já existe um tipo de realização cadastrado com o tipo"
        )
      ) {
        handleModalStatus({
          type: "hasExist",
          showModal,
        });
      } else {
        handleModalStatus({
          type: "error",
          showModal,
        });
      }
    }
  };

  return (
    <MainContent>
      <SubTitle>
        <h3>Incluir</h3>
      </SubTitle>

      <FormContainer>
        <div style={{ flex: 1 }}>
          <Input
            name="tipo"
            control={control}
            rules={{ ...valueIsRequired() }}
            placeholder="Tipo de registro"
            maxLength={140}
          />
          <Input
            name="descricao"
            control={control}
            rules={{ ...valueIsRequired() }}
            placeholder="Descrição do registro"
            maxLength={140}
          />
          <TextArea
            name="regrasServico"
            control={control}
            rules={{ ...valueIsRequired() }}
            placeholder="Regras específicas do serviço"
          />

          <Input
            name="nome"
            control={control}
            rules={{ ...valueIsRequired() }}
            placeholder="Sobre o registro"
            maxLength={140}
          />
          <Input
            name="acaoRegistro"
            control={control}
            rules={{ ...valueIsRequired() }}
            placeholder="Ação do registro"
            maxLength={140}
          />
        </div>

        <div style={{ flex: 1, paddingBottom: "1rem" }}>
          <FlexDirectionRow
            position={"end"}
            align={"end"}
            style={{
              marginRight: "40px",
              width: "100%",
              height: "100%",
            }}
          >
  
            <Button
                type="button"
                backgroundColor={"#9CA2A8"}
                onClick={() => reset()}
                style={{
                  marginRight: '20px'
                }}
            >
              Limpar
            </Button>
            
            <Button
              href="#"
              disabled={isSubmitting}
              onClick={handleSubmit(submitForm)}
            >
              {isSubmitting ? (
                <Spinner radius={5} color={"#fff"} stroke={2} visible={true} />
              ) : (
                "Incluir tipo de registro"
              )}
            </Button>
          </FlexDirectionRow>
        </div>
      </FormContainer>
    </MainContent>
  );
};
